interface ListenerItem {
  type: string;
  callback: any;
}
let queue: ListenerItem[] = [];

// 获取通天塔消息
function listenMessage(type: string, callback = (arg: any) => {}) {
  if (queue.length === 0) {
    window.addEventListener('message', _receiveMessage, false);
  }

  queue = queue.slice();
  queue.push({ type, callback });

  let mounted = true;

  return function removeListener() {
    if (!mounted) return;
    mounted = false;
    queue = queue.filter((listener) => {
      return listener.type !== type || listener.callback !== callback;
    });

    if (queue.length === 0) window.removeEventListener('message', _receiveMessage, false);
  };
}

function _receiveMessage(event: any) {
  const message = event.data;

  if (typeof message === 'undefined') return;
  const { type, payload } = message;

  if (typeof type === 'undefined') return;

  _triggerEv(type, payload);
}

function _triggerEv(type: string, payload: any) {
  const _queue = queue;

  _queue.forEach((item) => {
    if (item.type === type) item.callback(payload);
  });
}

export default listenMessage;
